import { Routes, Route, Router } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

import Header from "../../layout/Header";
import SideNav from "../../layout/SideNav";
import Footer from "../../layout/Footer";

import Dashboard from "../../pages/Dashboard";
import Passenger from "../../pages/Passeneger";
import Dispatch from "../../pages/Dispatch";
import Driver from "../../pages/Drivers/Drivers";
import DriverPayment from "../../pages/Payment/DriverPayment";
import AllRides from "../../pages/Rides/AllRides";
import VehicleType from "../../pages/Vehicle/VehicleType";
import Setting from "../../pages/Setting/Setting";
import DriverDocument from "../../pages/Document/DriverDocument";
import DocumentList from "../../pages/Document/DocumentList";
import Dispatchers from "../../pages/Dispatchers";
import VehicleListByDriver from "../../pages/Vehicle/VehicleListByDriver";
import RidesForDriver from "../../pages/Rides/RidesForDriver";
import VehicleList from "../../pages/Vehicle/VehicleList";
import CancelledRides from "../../pages/Rides/CancelledRides";
import PendingRides from "../../pages/Rides/PendingRides";
import TrackUsers from "../../pages/TrackUsers";
import GetDriverByVehicle from "../../pages/Drivers/GetDriverByVehicle";
import OnlineDrivers from "../../pages/Drivers/OnlineDrivers";
import UnApprovedDrivers from "../../pages/Drivers/UnApprovedDrivers";
import Schedule from "../../pages/Booking";

import AddPassenger from "../../forms/passengers/AddEditPassenger";
import DriverStatement from "../../forms/driver/DriverStatement";
import AddVehicleType from "../../forms/vehicle/AddVehicleType";
import AddDocumentType from "../../forms/document/AddDocumentType";
import AddVehicle from "../../forms/vehicle/AddVehicle";
import UpdateAccStatus from "../../forms/driver/UpdateAccStatus";
import AdminPayment from "../../pages/Payment/AdminPayment";
import AdminProfileUpdate from "../../pages/Profile";
import ServiceCategory from "../../pages/Vehicle/ServiceCategory";
import Notification from "../../pages/Notification";

function PrivateRoute() {
  const { user } = useSelector((state) => state.auth);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (user && user.role === "ADMIN") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
  }, [user]);
  return (
    <>
      <div className="flex flex-col min-h-screen">
        <Header />
        <div className="flex flex-1">
          <SideNav />
          <main className="flex-1 p-6">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/profile" element={<AdminProfileUpdate />} />
              <Route path="/dispatch" element={<Dispatch />} />
              <Route path="/driver-statement" element={<DriverStatement />} />
              <Route path="/rides" element={<AllRides />} />
              <Route path="/driver-payment" element={<DriverPayment />} />
              {isAdmin && (
                <>
                  <Route
                    path="/unapproved-drivers"
                    element={<UnApprovedDrivers />}
                  />
                  <Route path="/passengers" element={<Passenger />} />
                  <Route path="/drivers" element={<Driver />} />
                  <Route path="/vehicle-type" element={<VehicleType />} />
                  <Route path="/add-passenger" element={<AddPassenger />} />
                  <Route path="/dispatchers" element={<Dispatchers />} />
                  <Route path="/admin-payment" element={<AdminPayment />} />
                  <Route
                    path="/add-vehicle-type"
                    element={<AddVehicleType />}
                  />
                  <Route path="/setting" element={<Setting />} />
                  <Route path="/driver-document" element={<DriverDocument />} />
                  <Route path="/document-list" element={<DocumentList />} />
                  <Route
                    path="/add-document-type"
                    element={<AddDocumentType />}
                  />
                  <Route path="/service-type" element={<ServiceCategory />} />
                  <Route
                    path="/vehicle-list-by-driver"
                    element={<VehicleListByDriver />}
                  />
                  <Route path="/vehicle-list" element={<VehicleList />} />
                  <Route path="/add-vehicle" element={<AddVehicle />} />
                  <Route
                    path="/update-account-status-for-driver"
                    element={<UpdateAccStatus />}
                  />
                  <Route path="/notification" element={<Notification />} />
                </>
              )}

              <Route path="/rides-for-driver" element={<RidesForDriver />} />
              <Route path="/canceled-rides" element={<CancelledRides />} />
              <Route path="/pending-rides" element={<PendingRides />} />
              <Route path="/track-users" element={<TrackUsers />} />
              <Route
                path="/get-driver-by-vehicle"
                element={<GetDriverByVehicle />}
              />
              <Route path="/online-drivers" element={<OnlineDrivers />} />
              <Route path="/booking" element={<Schedule />} />
            </Routes>
          </main>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default PrivateRoute;
